import styled from "styled-components";
import { borderRadius, fontWeights, spacing, typographyMixin } from "@magicbi/ui-library";
import { Callout, LinkButton } from "../DistributionStepSection/DistributionStepSection.styles";

export const Thumbs = styled.div`
  display: flex;
  gap: ${spacing[1.5]};
`;

/** The design's near-black tile: the inverse surface. */
export const Thumb = styled.div`
  flex: 1;
  min-width: 0;
  aspect-ratio: 16 / 10;
  padding: ${spacing[1.5]};
  border-radius: ${borderRadius.md};
  background: ${({ theme }) => theme.colors.background.inverse};
  color: ${({ theme }) => theme.colors.text.inverse};
  ${typographyMixin("caption", 2)}
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Rows = styled.dl`
  display: grid;
  gap: ${spacing[2]};
  margin: 0;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 7.5rem minmax(0, 1fr);
  gap: ${spacing[3]};
  ${typographyMixin("body", 4)}
`;

export const RowLabel = styled.dt`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const RowValue = styled.dd`
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};
`;

/** The info banner: a tinted band, the prompt, then the shortcut link. */
export const TestBand = styled(Callout)`
  align-items: center;
  gap: ${spacing[3]};
`;

export const TestLink = styled(LinkButton)`
  flex: none;
  font-weight: ${fontWeights.semibold};
  color: ${({ theme }) => theme.colors.interactive.primary};
  &:hover {
    text-decoration: none;
  }
`;

export const TestText = styled.span`
  flex: 1;
`;
